import { render, staticRenderFns } from "./createOffstandardProductsThird.vue?vue&type=template&id=756d3600&scoped=true"
import script from "./createOffstandardProductsThird.vue?vue&type=script&lang=js"
export * from "./createOffstandardProductsThird.vue?vue&type=script&lang=js"
import style0 from "./createOffstandardProductsThird.vue?vue&type=style&index=0&id=756d3600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d3600",
  null
  
)

export default component.exports